import type {
  TicketCreateRequest,
  PleasedChatRequest,
  PleasedVoiceRequest,
  PleasedSupportRequest,
} from './usePleasedSupport.types';

export const SupportType = {
  chat: 'chat',
  voice: 'voice',
  openRequest: 'openRequest',
} as const;

export type PleasedSupportKind = keyof typeof SupportType;

function createEventIdentifier<K>(type: PleasedSupportKind) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (event: any): event is K => event?.type === type;
}

export const isChatRequest = createEventIdentifier<PleasedChatRequest>(SupportType.chat);
export const isVoiceRequest = createEventIdentifier<PleasedVoiceRequest>(SupportType.voice);
export const isTicketRequest = createEventIdentifier<TicketCreateRequest>(SupportType.openRequest);

interface CreateEvent {
  (evt: PleasedChatRequest): PleasedChatRequest;
  (evt: PleasedVoiceRequest): PleasedVoiceRequest;
  (evt: TicketCreateRequest): TicketCreateRequest;
  (evt: PleasedSupportRequest): PleasedSupportRequest;
}

export const createSupportRequest = ((evt) => ({ ...evt })) as CreateEvent;
